<app-evida-error
    icon="evida_error_locked"
    [showRetryButton]="false"
    (retryClicked)="retry()"
    [showCorrelationId]="false"
>
    <h2 class="header-medium" translate="shared.errormessages.status423.title"></h2>
    <p>
        <span translate="shared.errormessages.status423.description1"></span>
        <br />
        <span translate="shared.errormessages.status423.description2"></span>
        <strong translate="shared.errormessages.status423.description3"></strong>
    </p>
</app-evida-error>
